{
  // === Parse rates ===
  const rateCsv = `Pokémon@C/UC@0.01
Pokémon@Rare@0.03
Pokémon@Reverse/Holo@0.035
Pokémon@V, ex, GX, EX@0.50
Pokémon@BREAK@0.25
Pokémon@VMAX@1.00
Pokémon@VSTAR@0.75
Magic: the Gathering@C/UC@0.004
Magic: the Gathering@Rare@0.05
Magic: the Gathering@Mythic@0.10
Yu-gi-oh!@Common/Rare@0.008
Yu-gi-oh!@Super Rare@0.03
Yu-gi-oh!@Ultra/Secret Rare@0.05
Yu-gi-oh!@Ultimate@0.25
Yu-gi-oh!@Ghost@1.00
Disney Lorcana@C/UC@0.01
Disney Lorcana@Rare@0.05
Disney Lorcana@Foil C/UC@0.05
Disney Lorcana@Foil Rare@0.08
Disney Lorcana@Super Rare@0.10
Disney Lorcana@Foil Super Rare@0.25
Disney Lorcana@Legendary@0.50
Disney Lorcana@Foil Legendary@1.00
One Piece@C/UC@0.008`;

  function parseRates(csv) {
    /*
    // Default option; 0 rate will appear as N/A
    const rates = {
      '--Please select a game--': {
        '--Please select a rarity--': 0,
      },
    };
    */
    const rates = {};

    const rows = csv.split('\n');
    for (const row of rows) {
      const [game, rarity, price] = row.split('@');
      if (!(game in rates)) rates[game] = {};
      rates[game][rarity] = parseFloat(price);
    }

    return rates;
  }

  const RATES = parseRates(rateCsv);
  console.debug(RATES);

  // === Dynamic bulk rows ===
  function createOption(value) {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = value;
    return option;
  }

  const totals = []; // to calculate subtotal

  const $bulk = document.querySelector('.bulk tbody');
  const $subtotal = document.querySelector('.bulk__subtotal');
  const $subtotalInput = document.querySelector('input[name="contact[Subtotal]"]');

  class BulkRow extends HTMLTableRowElement {
    static ID = 0;

    constructor() {
      super();
    }

    connectedCallback() {
      const $template = document.getElementById('bulk__row').content;
      this.replaceChildren(...$template.cloneNode(true).children);
      this.dataset.id = BulkRow.ID++;

      // Cache elements
      this.$game = this.querySelector('.bulk__game');
      this.$rarity = this.querySelector('.bulk__rarity');
      this.$quantity = this.querySelector('.bulk__quantity');
      this.$rate = this.querySelector('.bulk__rate');
      this.$total = this.querySelector('.bulk__total');

      // Populate game options
      this.$game.replaceChildren(...Object.keys(RATES).map((g) => createOption(g)));

      // Populate initial rarities and rate based on default game
      this.updateRarities();
      this.updatePricing();

      // Update row options and pricing when inputs change
      this.$rarity.addEventListener('change', () => this.updatePricing());
      this.$quantity.addEventListener('change', () => {
        this.updatePricing();
        // Only send form data if quantity is set
        if (this.$quantity.value > 0) {
          this.$quantity.setAttribute(
            'name',
            `contact[${this.$game.value}-${this.$rarity.value}-Row_${this.dataset.id}]`
          );
        } else {
          this.$quantity.removeAttribute('name');
        }
      });
      this.$game.addEventListener('change', () => {
        this.updateRarities();
        this.updatePricing();
      });
    }

    updateRarities() {
      this.$rarity.replaceChildren(...Object.keys(RATES[this.$game.value]).map((r) => createOption(r)));
    }

    updatePricing() {
      const rate = RATES[this.$game.value][this.$rarity.value];
      this.$rate.textContent = rate ? '$' + rate.toFixed(3) : 'N/A';

      const rowTotal = this.$quantity.value * rate;
      this.$total.textContent = '$' + rowTotal.toFixed(3);

      totals[this.dataset.id] = rowTotal;
      const subtotal = totals.reduce((sum, total) => sum + total);
      $subtotal.textContent = '$' + subtotal.toFixed(3);
      $subtotalInput.value = subtotal.toFixed(3);
    }
  }
  customElements.define('bulk-row', BulkRow, { extends: 'tr' });

  // Buttons to add new rows to table
  function addRows(n) {
    for (let i = 0; i < n; i++) {
      $bulk.append(new BulkRow());
    }
  }
  const addRowBtns = document.querySelectorAll('.bulk__add-row');
  for (const btn of addRowBtns) {
    btn.addEventListener('click', () => addRows(+btn.dataset.rows));
  }

  // Initial rows
  addRows(5);
}
